import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import enActivityTypesTranslations from "./locales/activity-types/en.json";
import frActivityTypesTranslations from "./locales/activity-types/fr.json";
import enAdminTranslations from "./locales/admin/en.json";
import frAdminTranslations from "./locales/admin/fr.json";
import enChatTranslations from "./locales/chat/en.json";
import frChatTranslations from "./locales/chat/fr.json";
import enCommonTranslations from "./locales/common/en.json";
import frCommonTranslations from "./locales/common/fr.json";
import enCompanyTranslations from "./locales/company/en.json";
import frCompanyTranslations from "./locales/company/fr.json";
import enComponentsTranslations from "./locales/components/en.json";
import frComponentsTranslations from "./locales/components/fr.json";
import enEmployeeTranslations from "./locales/employee/en.json";
import frEmployeeTranslations from "./locales/employee/fr.json";
import enListingTranslations from "./locales/listing/en.json";
import frListingTranslations from "./locales/listing/fr.json";
import enPromptTranslations from "./locales/prompt/en.json";
import frPromptTranslations from "./locales/prompt/fr.json";
import enProspectingTranslations from "./locales/prospecting/en.json";
import frProspectingTranslations from "./locales/prospecting/fr.json";
import enReferralsTranslations from "./locales/referrals/en.json";
import frReferralsTranslations from "./locales/referrals/fr.json";
import enSettingsTranslations from "./locales/settings/en.json";
import frSettingsTranslations from "./locales/settings/fr.json";
import enSetupTranslations from "./locales/setup/en.json";
import frSetupTranslations from "./locales/setup/fr.json";
import enTeamTranslations from "./locales/team/en.json";
import frTeamTranslations from "./locales/team/fr.json";
import enUserTranslations from "./locales/user/en.json";
import frUserTranslations from "./locales/user/fr.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: {
          ...enActivityTypesTranslations,
          ...enCommonTranslations,
          ...enListingTranslations,
          ...enCompanyTranslations,
          ...enEmployeeTranslations,
          ...enAdminTranslations,
          ...enChatTranslations,
          ...enPromptTranslations,
          ...enProspectingTranslations,
          ...enSetupTranslations,
          ...enTeamTranslations,
          ...enSettingsTranslations,
          ...enComponentsTranslations,
          ...enUserTranslations,
          ...enReferralsTranslations,
        },
      },
      fr: {
        translation: {
          ...frActivityTypesTranslations,
          ...frCommonTranslations,
          ...frListingTranslations,
          ...frCompanyTranslations,
          ...frEmployeeTranslations,
          ...frAdminTranslations,
          ...frChatTranslations,
          ...frPromptTranslations,
          ...frProspectingTranslations,
          ...frSetupTranslations,
          ...frTeamTranslations,
          ...frSettingsTranslations,
          ...frComponentsTranslations,
          ...frUserTranslations,
          ...frReferralsTranslations,
        },
      },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "fr"],
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
